webpackJsonp([17],{

/***/ "0qbV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/wave-section-how-work_8c1581f1679fc01c8a8e47589666fd6c.html";

/***/ }),

/***/ "V2FM":
/***/ (function(module, exports, __webpack_require__) {

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var WaveSectionHowWork = (function () {
    function WaveSectionHowWork() {
        var _this = this;
        this.steps = [
            {
                name: 'choose-video',
                title: 'subtitle1',
                content: 'text1',
                anonymousBtnName: 'link1',
                btnName: 'link1',
                videoUrl: 'step1'
            },
            {
                name: 'add-text',
                title: 'subtitle2',
                content: 'text2',
                anonymousBtnName: 'link2',
                btnName: 'link2',
                videoUrl: 'step2'
            },
            {
                name: 'cta',
                title: 'subtitle3',
                content: 'text3',
                anonymousBtnName: 'link3',
                btnName: 'link3',
                videoUrl: 'step3'
            },
            {
                name: 'choose-music',
                title: 'subtitle4',
                content: 'text4',
                anonymousBtnName: 'link4',
                btnName: 'link4',
                videoUrl: 'step4'
            },
            {
                name: 'import-files',
                title: 'import-files.title',
                content: 'import-files.content',
                anonymousBtnName: 'btnName',
                btnName: 'btnName',
                videoUrl: 'lu_step1'
            },
            {
                name: 'choose-video-2',
                title: 'choose-video-2.title',
                content: 'choose-video-2.content',
                anonymousBtnName: 'btnName',
                btnName: 'btnName',
                videoUrl: 'lu_step2'
            },
            {
                name: 'customize-video',
                title: 'customize-video.title',
                content: 'customize-video.content',
                anonymousBtnName: 'btnName',
                btnName: 'btnName',
                videoUrl: 'lu_step3'
            },
            {
                name: 'preview-results',
                title: 'preview-results.title',
                content: 'preview-results.content',
                anonymousBtnName: 'btnName',
                btnName: 'btnName',
                videoUrl: 'lu_step4'
            },
        ].map(function (step) { return _this.mapSteps(step); });
    }
    WaveSectionHowWork.prototype.mapSteps = function (step) {
        var getTranslate = function (val) { return "wv.landing.content.block2." + val; };
        var getVideoUrl = function (val) { return "https://videos.animatron.com/landing/wave/" + val + ".mp4"; };
        return __assign({}, step, { title: getTranslate(step.title), content: getTranslate(step.content), anonymousBtnName: getTranslate(step.anonymousBtnName), btnName: getTranslate(step.btnName), videoUrl: getVideoUrl(step.videoUrl) });
    };
    WaveSectionHowWork.prototype.$onChanges = function () {
        var _this = this;
        if (!this.stepsNames)
            return;
        this.steps = this.stepsNames.map(function (stepName) {
            return _this.steps.filter(function (step) { return step.name === stepName; })[0];
        });
    };
    return WaveSectionHowWork;
}());
angular.module('animatronApp.wave.sectionHowWork', []).component('waveSectionHowWork', {
    bindings: {
        stepsNames: '<',
        reverse: '<'
    },
    transclude: true,
    controller: WaveSectionHowWork,
    templateUrl: __webpack_require__("0qbV")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/17-82c0e6a2dceb23823569.min.js